import * as sentry from '@sentry/browser';
import mapStackTrace from 'sourcemapped-stacktrace';
import { has, pickBy } from 'lodash';
import environment from './lib/environment';
import safeStringify from './lib/safeStringify';

const reportToSentry = !environment.isDevelopment() && !environment.isTest();

// eslint-disable-next-line
function setupJSRemoteTrackError() {
  sentry.init({
    dsn: 'https://3a75297119d14ac290b3f335b553b1b0@sentry.io/1279798',
  });
}
if (reportToSentry) setupJSRemoteTrackError();

/**
* @param {Error} error Error object with stacktrace apply sourcemap to.
* @returns {Promise<[]String>}
*/
export const getMappedStack = async error => new Promise((done) => {
  if (error.stack) {
    mapStackTrace.mapStackTrace(error.stack, done);
  } else {
    done();
  }
});

const doNotReportProps = new Set([
  'token',
]);

export default [
  'log',
  'info',
  'warn',
  'debug',
].reduce((logger, type) => ({
  ...logger,
  // eslint-disable-next-line no-console
  [type]: console[type].bind(console),
}), {
  error: async (arg) => {
    // eslint-disable-next-line no-console
    console.error(arg);

    let error = arg;
    if (typeof error === 'string') {
      error = new Error(arg);
    } else if (error.stack instanceof Array) {
      error = {
        ...error,
        stack: error.stack.join('\n'),
      };
    }

    if (reportToSentry) {
      sentry.captureException(error);
    } else {
      let mappedStack = await getMappedStack(error);
      if (!mappedStack) {
        mappedStack = [];
      }

      const context = {
        message: error.message,
        mappedStack,
        componentInfo: error.componentInfo,
      };
      if (has(context, 'componentInfo.props')) {
        context.componentInfo.props = pickBy(
          error.componentInfo.props,
          (_value, key) => !doNotReportProps.has(key),
        );
      }
      // eslint-disable-next-line no-alert
      alert(safeStringify(context));
    }
  },
});
